import { useQuery } from '@tanstack/react-query';
import { http, returnIfNotFoundError } from 'services/http';
import { CLIENT_INSURANCE } from 'api/query-keys';
import type { TClientInsuranceRes } from 'api/swagger';

export const useGetClientInsurance = (clientId: number) => {
  return useQuery<TClientInsuranceRes | null>({
    queryKey: [CLIENT_INSURANCE, clientId],
    queryFn: async () => {
      try {
        const { data } = await http.get<TClientInsuranceRes | null>(`/v1/clients/${clientId}/insurance`);
        return data;
      } catch (error) {
        return returnIfNotFoundError(error, null);
      }
    },
    retry: false,
    refetchOnWindowFocus: false,
  });
};
